const de = {
    "sc_title": "Security Center",
    "sc_subtitle": "GaiaShield Integrated Security Layer",
    "sc_tab_status": "🛡️ Schutzstatus",
    "sc_tab_events": "📋 Sicherheitsprotokoll",
    "sc_tab_node": "⚙️ Node-Sicherheit",
    "sc_loading": "Lade Sicherheitsdaten...",
    "sc_status_secured": "Systemstatus: Konto ist geschützt",
    "sc_status_warning": "Systemstatus: Warnungen aktiv",
    "sc_desc_secured": "Es liegen keine offenen kritischen Sicherheitswarnungen vor. GaiaShield überwacht dein Konto aktiv.",
    "sc_desc_warning": "Achtung: Es gibt offene Sicherheitsereignisse, die deine Aufmerksamkeit erfordern.",
    "sc_account_protection": "Konto-Schutz",
    "sc_message_protection": "Nachrichten-Schutz",
    "sc_audits": "Sicherheitsprüfungen",
    "sc_active": "AKTIV",
    "sc_failed_logins": "Fehlgeschlagene Logins",
    "sc_tamper_checks": "Manipulationsprüfungen",
    "sc_blocked_replays": "Blockierte Replays",
    "sc_last_check": "Letzte Prüfung",
    "sc_just_now": "Gerade eben",
    "sc_open_warnings": "Offene Warnungen",
    "sc_btn_acknowledge": "Bestätigen",
    "sc_filter_severity": "Dringlichkeit",
    "sc_filter_category": "Kategorie",
    "sc_filter_hide_ack": "Bestätigte ausblenden",
    "sc_btn_export": "Exportieren",
    "sc_col_details": "Details",
    "sc_col_time": "Zeit",
    "sc_col_status": "Status",
    "sc_col_action": "Aktion",
    "sc_no_events": "Keine Sicherheitsereignisse gefunden.",
    "sc_node_title": "Node-Betreiber-Sicherheitskonsole",
    "sc_system_health": "Systemgesundheit",
    "sc_last_audit": "Letztes Audit",
    "sc_packed_logs": "Gepackte Logs",
    "sc_unconfirmed_events": "Unbestätigte Events",
    "sc_operator_action": "Betreiber-Aktion erforderlich",
    "sc_all_ok": "Alles in Ordnung",
    "sc_critical_events": "Kritische Systemereignisse",
    "ac_title": "Governance- & Meldecenter",
    "ac_subtitle": "GaiaCom Governance & Abuse Consensus",
    "ac_tab_my_reports": "Meine Meldungen",
    "ac_tab_queue": "Review Warteschlange",
    "ac_tab_operator": "Node Operator",
    "ac_tab_transparency": "Föderation & Transparenz",
    "ac_loading": "Lade Daten...",
    "ac_reported_cases": "Gemeldete Fälle",
    "ac_no_reports": "Sie haben noch keine Meldungen eingereicht.",
    "ac_case_details": "Fall-Details",
    "ac_appeal_submit": "Einspruch einlegen",
    "ac_appeal_status": "Status des Einspruchs",
    "ac_appeal_reason": "Grund für den Einspruch",
    "ac_appeal_statement": "Stellungnahme",
    "ac_btn_appeal": "Einspruch abschicken",
    "ac_trusted_reviewer_queue": "Trusted Reviewer Warteschlange",
    "ac_case_review": "Fall überprüfen (Review)",
    "ac_review_category": "Empfohlene Kategorie",
    "ac_review_severity": "Empfohlener Schweregrad",
    "ac_review_action": "Empfohlene Maßnahme",
    "ac_review_reason": "Begründung des Reviewers",
    "ac_btn_submit_review": "Review einreichen",
    "ac_node_operator_dashboard": "Node Operator Dashboard",
    "ac_apply_action": "Maßnahme anwenden (Override)",
    "ac_target_type": "Ziel-Typ",
    "ac_target_id": "Ziel-ID (GaiaID oder Channel ID)",
    "ac_suspend": "Sperrung aktiv (Suspend)",
    "ac_reason": "Offizielle Begründung",
    "ac_btn_apply": "Maßnahme durchsetzen",
    "ac_transparency_title": "Konsens- & Transparenz-Logbuch",
    "ac_transparency_desc": "Öffentlich einsehbare Snapshot-Nachweise aller moderierten Kanäle und Identitäten.",
    "ac_btn_snapshot": "Transparenz-Snapshot erzeugen",
    "search_placeholder": "Mails nach Betreff, Sender, Text suchen...",
    "abuse_center_title": "Meldecenter",
    "abbrechen": "Abbrechen",
    "active_identities": "Aktive Identitäten",
    "active_identity": "Aktive Identität",
    "add_btn": "Hinzufügen",
    "add_contact_title": "Kontakt hinzufügen",
    "admin": "Admin",
    "adressbuch": "Adressbuch",
    "aktiviert": "Aktiviert",
    "an": "An",
    "anonymous_sender": "Anonymer Absender",
    "antworten": "Antworten",
    "attachment_gaia_hint": "GaiaCOM-Anhänge bleiben Ende-zu-Ende verschlüsselt.",
    "attachment_smtp_hint": "Legacy-SMTP blockt ausführbare/scriptartige Anhänge und speichert Mails als unsicher.",
    "attachments": "Anhänge",
    "auffaellig": "Auffällig",
    "auth_beta_notice": "Beta-Testphase: GaiaCOM wird aktiv getestet. Fehler können auftreten; sichere wichtige Seeds und prüfe vertrauliche Workflows sorgfältig.",
    "auth_btn_login": "Identität laden & einloggen",
    "auth_btn_register": "Registrieren & Krypto erstellen",
    "auth_copied": "Kopiert",
    "auth_copy_seed": "Seed kopieren",
    "auth_generate_seed": "Seed generieren",
    "auth_headline": "GaiaCOM ist das erste quantensichere E-Mail-Protokoll und Kommunikationssystem, gebaut für die Menschheit.",
    "auth_kicker": "Post-Quantum Secure Communication",
    "auth_mnemonic": "Mnemonic-Phrase",
    "auth_mnemonic_placeholder": "12 Wörter durch Leerzeichen getrennt...",
    "auth_password": "Passwort",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Private Schlüssel verlassen dein Gerät nicht. Nur die vorgesehenen Empfänger können Inhalte entschlüsseln.",
    "auth_proof_gaiadata_desc": "Zero-Knowledge: Du behältst die Kontrolle über deine Daten. Metadaten werden minimiert und nicht als Klartext-Profil verwertet.",
    "auth_proof_gaiadrop_desc": "Externe Personen können vertrauliche Text-Hinweise ohne Account an deine GaiaID senden.",
    "auth_proof_gaiaproof_desc": "Zustell- und Integritätsbeweise zeigen, dass Ciphertext, Sender und Zeitstempel nicht manipuliert wurden.",
    "auth_proof_gaiavault_desc": "Private Notizen, Recovery-Hinweise und Security Records bleiben lokal verschlüsselt.",
    "auth_proof_hybrid_desc": "Quantum Shield: Hybride Verschlüsselung mit ML-KEM und X25519 schützt gegen heutige Angriffe und Store-Now-Decrypt-Later-Risiken.",
    "auth_secure_mail": "Secure Quantum Federated Mail",
    "auth_subline": "GaiaCOM ist ein quantensicheres Kommunikationssystem für E-Mail, Chat, Krisenräume, GaiaDrop und lokale Sicherheitsakten. Private Schlüssel bleiben auf deinem Gerät, Inhalte werden Ende-zu-Ende verschlüsselt und Beweise können ohne Klartext exportiert werden.",
    "auth_success_btn": "Jetzt einloggen",
    "auth_success_text": "Dein GaiaCOM-Konto wurde erstellt. Die Schlüssel wurden lokal aus deinem Seed abgeleitet und nicht auf dem Server gespeichert.",
    "auth_success_title": "Registrierung erfolgreich",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Login / Account",
    "auth_toggle_login": "Bereits Account vorhanden",
    "auth_toggle_register": "Neuen Account erstellen",
    "auth_usecase_text": "Geeignet für Anwälte, Unternehmen, Behörden, Journalisten, Whistleblower und private Sicherheitsfälle.",
    "auth_usecase_title": "Für sensible Kommunikation gebaut",
    "auth_username": "Benutzername",
    "auth_username_placeholder": "Name eingeben...",
    "auth_value_chat": "E2E Chat",
    "auth_value_drop": "Secure Drop",
    "auth_value_mail": "Sichere Mail",
    "auth_value_rooms": "GaiaRooms",
    "bestaetigen": "Bestätigen",
    "bestaetigt": "Bestätigt",
    "bio_status": "Biografie / Status",
    "biography": "Biografie",
    "change_password_desc": "Ändert dein serverseitiges Login-Passwort. Deine lokale Recovery Phrase bleibt separat durch dein Vault-/Unlock-Passwort geschützt.",
    "change_password_menu_desc": "GaiaCOM Login-Passwort aktualisieren.",
    "change_password_title": "Passwort ändern",
    "channel_id": "Kanal-ID",
    "channel_name_label": "Kanalname",
    "chat_deleted_hidden": "Chat gelöscht und ausgeblendet.",
    "chat_input_placeholder": "Sichere Nachricht eingeben...",
    "chat_start_hint": "Starten Sie die Konversation! Alle Chat-Nachrichten sind quantensicher E2E verschlüsselt.",
    "choose_avatar": "Avatar wählen",
    "ciphertext_hash": "Ciphertext Hash",
    "clear_chat": "Chat leeren",
    "clear_for_everyone": "Für alle leeren",
    "clear_for_me": "Nur für mich leeren",
    "click_to_write_mail": "Klicken zum Schreiben einer Mail",
    "click_top_right": "Klicke oben rechts auf",
    "close": "Schließen",
    "code_kopieren": "Code kopieren",
    "code_kopieren_success": "Code kopiert",
    "confirm_clear_channel_desc": "Möchtest du diesen Kanal aus deiner lokalen Ansicht leeren?",
    "confirm_clear_channel_title": "Kanal leeren",
    "confirm_clear_chat": "Möchtest du diesen Chat leeren?",
    "confirm_clear_chat_desc": "Möchtest du diesen Chat leeren?",
    "confirm_clear_chat_title": "Chat leeren",
    "confirm_clear_everyone": "Möchtest du den Chat für beide Partner leeren? (OK = Für alle, Abbrechen = Nur für mich)",
    "confirm_delete_everyone": "Möchtest du die Nachricht für beide Partner löschen? (OK = Für alle, Abbrechen = Nur für mich)",
    "confirm_delete_msg": "Möchtest du diese Nachricht löschen?",
    "confirm_delete_msg_desc": "Möchtest du diese Chat-Nachricht löschen?",
    "confirm_delete_msg_title": "Nachricht löschen",
    "confirm_new_password": "Neues Passwort bestätigen",
    "copy": "Kopieren",
    "create_btn": "Erstellen",
    "create_channel_title": "Kanal erstellen",
    "create_group_is_crisis": "Als Krisenraum markieren",
    "create_group_title": "Neue Gruppe erstellen",
    "crypto_lock_desc": "Steuert, wann GaiaCOM lokale Kryptoschlüssel wieder aus dem Arbeitsspeicher entfernt.",
    "crypto_lock_menu_desc": "Geräte-Code, WebAuthn und Auto-Sperre steuern.",
    "crypto_lock_title": "Geräte-Schlüssel & Sperre",
    "crypto_session_duration": "Entsperrt nach Reload",
    "crypto_session_duration_desc": "Hält die Kryptositzung nur für die gewählte Dauer in diesem Browser-Tab offen.",
    "cryptographic_fingerprint": "Kryptographischer Fingerprint",
    "current_password": "Aktuelles Passwort",
    "data_minimization": "Datenminimierung",
    "decrypt_failed": "Nicht entschlüsselbar",
    "delete": "Löschen",
    "delete_account_button": "Account unwiderruflich löschen",
    "delete_account_confirm_label": "Zur Bestätigung DELETE eingeben",
    "delete_account_confirmation_error": "Passwort und DELETE-Bestätigung sind erforderlich.",
    "delete_account_desc": "Dieser Modus vernichtet dein Konto, Identitäten, Gerätesitzungen, GaiaDrop-Daten, Upload-Metadaten und serverseitig zuordenbare Nachrichten unwiderruflich.",
    "delete_account_done_desc": "Alle zuordenbaren GaiaCOM-Daten wurden gelöscht.",
    "delete_account_done_title": "Account gelöscht",
    "delete_account_menu_desc": "Konto und zuordenbare Daten vernichten.",
    "delete_account_not_authenticated": "Kein aktiver Account.",
    "delete_account_title": "Account löschen",
    "delete_for_everyone": "Für alle löschen",
    "delete_for_me": "Nur für mich löschen",
    "device_current": "Dieses Gerät",
    "device_last_seen": "Zuletzt",
    "device_logout": "Abmelden",
    "device_sessions_desc": "Prüfe aktive Sitzungen und melde Geräte ab, denen du nicht mehr vertraust.",
    "device_sessions_empty": "Keine Geräte gefunden.",
    "device_sessions_menu_desc": "Aktive Sitzungen verwalten und beenden.",
    "device_sessions_title": "Angemeldete Geräte",
    "device_since": "Seit",
    "display_name": "Anzeigename",
    "drop_address_copied": "GaiaDrop-Adresse kopiert.",
    "drop_btn_decrypting": "Inbox wird entschlüsselt...",
    "drop_btn_load": "GaiaDrop Inbox laden",
    "drop_delete_desc": "Möchtest du diesen Drop wirklich unwiderruflich löschen?",
    "drop_delete_title": "GaiaDrop löschen",
    "drop_desc": "Text-only Zero-Knowledge Drop-Kanal für externe Hinweise, Responsible Disclosure und vertrauliche Meldungen. Externe können ohne Account unter Angabe deiner GaiaID Nachrichten senden.",
    "drop_empty": "Noch keine GaiaDrop Meldungen geladen.",
    "drop_id": "Drop-ID:",
    "drop_own_address": "Deine GaiaDrop-Adresse",
    "drop_proof": "DROP BEWEIS",
    "drop_title": "GaiaDrop Secure Inbox",
    "dunkler_modus": " Dunkler Modus",
    "e2e_chat_room_open": "E2E Chat-Raum öffnen",
    "edit_profile": "Profil bearbeiten",
    "edit_profile_desc": "Anzeigename, Biografie und Avatar anpassen.",
    "einladungscode": "Einladungscode",
    "enter_fingerprint_chars_confirm": "Gib die angeforderten Fingerprint-Zeichen zur Bestätigung ein.",
    "envelope_hash": "Envelope Hash",
    "erasability": "Löschbarkeit",
    "erfolg": "Erfolg",
    "exclude_plaintext": "Ohne Klartext exportieren",
    "export_disclosure": "Sicherheitsfall exportieren",
    "export_package_desc": "Klartext nur aufnehmen, wenn diese Offenlegung bewusst vorgesehen ist.",
    "export_package_title": "Sicherheits-Paket exportieren",
    "fehler": "Fehler",
    "gaiacom_reader": "GaiaCOM Reader",
    "gaiadrop_inbox_title": "GaiaDrop Posteingang",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM minimiert Metadaten, hält private Schlüssel lokal, verschluesselt Inhalte Ende-zu-Ende und ermoeglicht vollstaendige Account-Loeschung.",
    "gdpr_home_title": "100% DSGVO-konform",
    "gdpr_reason_delete": "Account-Loeschung entfernt Konto, Identitäten, lokale Sitzungen und serverseitig zuordenbare Daten.",
    "gdpr_reason_e2ee": "Private Inhalte bleiben nur für vorgesehene Empfänger entschluesselbar.",
    "gdpr_reason_minimal": "Metadaten werden nur für Routing, Zustellung und Sicherheitsnachweise genutzt.",
    "gdpr_reason_zero_knowledge": "Private Schlüssel und Recovery-Daten bleiben lokal unter Nutzerkontrolle.",
    "gesendet": "Gesendet",
    "gesperrt_verdaechtig": "Gesperrt / Verdächtig",
    "group_delete_desc": "Möchtest du diese Gruppe wirklich unwiderruflich löschen? Alle Kanäle und Nachrichten dieser Gruppe werden gelöscht.",
    "group_delete_title": "Gruppe löschen",
    "group_description": "Beschreibung",
    "group_icon_label": "Gruppen-Icon / Avatar",
    "group_name": "Gruppenname",
    "group_settings_avatar": "Avatar",
    "group_settings_desc": "Beschreibung",
    "group_settings_is_crisis": "Als Krisenraum markieren",
    "group_settings_name": "Gruppenname",
    "group_settings_title": "Gruppeneinstellungen",
    "groups_empty_desc": "Erstelle einen sicheren Arbeitsraum für Projekt-, Krisen- oder Teamkommunikation.",
    "groups_empty_title": "Noch keine Gruppen-Chats",
    "gruppe_beitreten": "Gruppe beigetreten",
    "gruppe_erstellen": "+ Gruppe erstellen",
    "gruppe_verlassen": "Gruppe verlassen",
    "gruppen_chats": "Gruppen-Chats",
    "heller_modus": " Heller Modus",
    "how_to_receive_drops": "Wie empfange ich Drops?",
    "identitaets_assistent": "Identitäts-Assistent",
    "inactivity_lock_duration": "Sperren bei Inaktivität",
    "inactivity_lock_duration_desc": "Nach dieser Zeit ohne Eingabe wird GaiaCOM automatisch kryptografisch gesperrt.",
    "inactivity_lock_notice": "GaiaCOM wurde wegen Inaktivität kryptografisch gesperrt.",
    "include_plaintext": "Klartext einschließen",
    "invite_code_label": "Einladungscode",
    "join_group_title": "Gruppe beitreten",
    "kanaele": "Kanäle",
    "kanal_erstellen": "+ Kanal",
    "kein_chat_ausgewaehlt": "Kein Chat ausgewählt",
    "kein_kanal_ausgewaehlt": "Kein Kanal ausgewählt",
    "keine_gruppe_ausgewaehlt": "Keine Gruppe ausgewählt",
    "keine_mails": "Keine Mails vorhanden.",
    "key_change_warn_desc": "Der öffentliche Schlüssel dieses Kontakts hat sich geändert. Prüfe den Fingerprint, bevor du ihm vertraust.",
    "key_change_warn_title": "Kryptographische Warnung",
    "key_change_warning_changed": "hat sich geändert. Dies kann ein Anzeichen für einen Man-in-the-Middle-Angriff sein!",
    "key_change_warning_msg": "Der Identitätsschlüssel für den Kontakt",
    "key_transparency": "Key Transparency (Schlüssel-Verlauf)",
    "kopiert": "Kopiert",
    "kryptographische_schluessel": "Kryptographische Schlüssel",
    "kryptographische_schluessel_desc": "Private Schlüssel und Backup Seed Phrase anzeigen.",
    "laden": "Laden...",
    "leeren": "Leeren",
    "loading": "Laden...",
    "local_key_vault": "Lokaler Schlüssel-Tresor",
    "local_keys_label": "Lokale Schlüssel",
    "lock_on_reload": "Immer nach Reload sperren",
    "logout": "Abmelden",
    "mail_compose": "Mail schreiben",
    "mein_profil": "Mein Profil",
    "melden": "Melden",
    "menu": "Menü",
    "message": "Nachricht",
    "message_id": "Message ID",
    "message_pin": "Anpinnen",
    "message_pinned_title": "Angepinnte Nachrichten",
    "message_react": "Reagieren",
    "message_reply": "Antworten",
    "message_replying_to": "Antwort auf",
    "message_save": "Speichern",
    "message_saved": "Gespeichert",
    "message_to_channel": "Nachricht an",
    "message_unpin": "Loesen",
    "message_unsave": "Nicht speichern",
    "mitglied": "Mitglied",
    "mitglieder": "Mitglieder",
    "ml_kem": "ML-KEM",
    "neue_mail": "Neue Mail",
    "never_auto_lock": "Nie automatisch",
    "new_fingerprint": "Neuer Fingerprint",
    "new_identity": "Neue Identität",
    "new_password": "Neues Passwort",
    "no_description": "Keine Beschreibung",
    "no_key_history": "Keine Schlüssel-Historie aufgezeichnet.",
    "no_specification": "Keine Angabe",
    "old_fingerprint": "Alter Fingerprint",
    "open_privacy_imprint": "Impressum und Datenschutz öffnen",
    "post_quantum_e2e": "Post-Quanten E2E",
    "posteingang": "Posteingang",
    "powered_by": "Powered by",
    "privacy_imprint_menu_desc": "DSGVO, Datenschutz und Impressum anzeigen.",
    "privacy_imprint_profile_desc": "GaiaCOM verarbeitet Kommunikationsinhalte nach dem Prinzip Datenminimierung, Ende-zu-Ende-Verschluesselung und lokaler Schluesselkontrolle.",
    "privacy_imprint_title": "Datenschutz & Impressum",
    "profil": "Profil",
    "profile_details": "Profil-Details",
    "profile_settings_hint": "Profil-Einstellungen werden im rechten Panel angezeigt.",
    "profile_unlock_desc": "Aus Sicherheitsgründen müssen Sie Ihr Passwort erneut eingeben, um Ihre privaten kryptographischen Schlüssel anzuzeigen.",
    "proof_hash": "Proof-Hash:",
    "public_drop_desc": "Secure Drop für externe Text-Hinweise ohne GaiaCOM Account.",
    "public_drop_message": "Nachricht",
    "public_drop_message_placeholder": "Vertraulichen Text eingeben...",
    "public_drop_send": "GaiaDrop senden",
    "public_drop_sender": "Absender-Hinweis optional",
    "public_drop_sender_placeholder": "Name, Aktenzeichen oder anonym",
    "public_drop_target": "Ziel-GaiaID",
    "quanten_chat": "Quanten-Chat",
    "quantum_secure_exchange": "Quantensicherer Austausch über...",
    "quantum_secure_net": "GaiaCOM Quantensicheres Netzwerk (Ed25519 & ML-KEM)",
    "quantum_shield_desc": "Das GaiaCOM-Netzwerk schützt Ihre Privatsphäre mit einem mehrschichtigen, hybriden Verschlüsselungs-Protokoll, das gegen Angriffe von zukünftigen Quantencomputern geschützt ist.",
    "quantum_shield_l1_desc": "Verwendet den FIPS 203 Standard zur Kapselung eines symmetrischen gemeinsamen Schlüssels. Verhindert das passive Aufzeichnen und spätere Entschlüsseln (\\\\\\",
    "quantum_shield_l1_title": "1. Post-Quanten-Schutz (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Ein klassisches, extrem schnelles Diffie-Hellman-Schlüsselaustauschverfahren, das als zusätzliche Sicherheitsebene im Hybridverfahren dient.",
    "quantum_shield_l2_title": "2. Elliptic-Curve-Kryptografie (X25519)",
    "quantum_shield_l3_desc": "Jede Nachricht und jeder Föderations-Umschlag wird kryptographisch signiert, um die Authentizität des Absenders zweifelsfrei zu verifizieren.",
    "quantum_shield_l3_title": "3. Digitale Signaturen (Ed25519)",
    "quantum_shield_l4_desc": "Verschlüsselt Nachrichteninhalte symmetrisch und bindet Absender, Empfänger und Metadaten fest in die Authentifizierten Zusatzdaten (AAD) ein, um Replay-Angriffe zu verhindern.",
    "quantum_shield_l4_title": "4. AAD Authentifizierung (AES-256-GCM)",
    "quantum_shield_status": " Quantum Shield Status",
    "receive_drops_step1": "Teile deine GaiaID (z. B. oben per Kopieren-Knopf) mit externen Quellen.",
    "receive_drops_step2": "Diese rufen die Login-Seite deiner GaiaCOM-Instanz auf, wechseln zum Reiter",
    "receive_drops_step3": "und senden dort ihre verschlüsselte Nachricht an deine Adresse.",
    "receiver_gaia": "GaiaCOM-Empfänger",
    "receiver_smtp": "SMTP-Empfänger",
    "records_stored": "Records gespeichert",
    "refresh": "Aktualisieren",
    "report_abuse_desc": "Möchtest du diese Nachricht melden und einen kryptographischen Missbrauchsbeweis an den Server übermitteln?",
    "report_abuse_title": "Missbrauch melden",
    "reputation_status": "Reputation Status",
    "room_chat_start_hint": "Starten Sie die Konversation! Alle Nachrichten in diesem Gruppenkanal sind dezentral quantensicher E2E verschlüsselt.",
    "room_policy_audit": "Audit-Trail und Key-Rotation aktiv.",
    "room_policy_crisis": "Krisenraum",
    "room_policy_e2ee": "Zero-Knowledge-Raum. E2EE quantensicher.",
    "room_policy_title": "Raum-Richtlinien",
    "room_policy_zero_knowledge": "Policy",
    "room_security_note_desc": "Alle Schlüsselwechsel werden über Key Transparency validiert. Nutze GaiaVault für private Backup-Logs.",
    "room_security_note_title": "Angeheftete Sicherheitsnotiz",
    "save_profile": "Profil speichern",
    "schluessel_entsperrt": "🔑 Schlüssel wieder sperren",
    "search_gaia_label": "Gaia-Adresse suchen",
    "security_warning_title": "Sicherheitswarnung",
    "select_channel_chat": "Wähle einen Kanal aus der linken Seitenleiste aus, um zu chatten.",
    "select_contact_chat": "Wähle einen Kontakt aus dem linken Panel aus, um einen quantensicheren E2E-Chat zu starten.",
    "select_mail_read": "Wähle eine Mail aus der Liste aus, um deren quantensichere Inhalte zu lesen, oder erstelle eine neue Nachricht.",
    "senden": "Senden",
    "sender_signature": "Sender Signature",
    "server_log": "Server-Log:",
    "server_received": "Server Received",
    "session_lock": "Sitzungssperre",
    "setup_address_keys": "Adresse und Schlüsselsatz anlegen",
    "setup_profile": "Im Profil einrichten",
    "smtp_inbox_title": "SMTP Empfang",
    "smtp_legacy_badge": "Legacy SMTP / Unsicher",
    "smtp_mode_option": "Legacy-SMTP-Bridge",
    "smtp_security_warning": "Diese Mail wurde über das klassische, unverschlüsselte SMTP-Protokoll übertragen. Keine End-to-End-Verschlüsselung aktiv.",
    "smtp_security_warning_desc": "Diese Nachricht verlässt den GaiaCom-Sicherheitsraum. SMTP-Zustellung bietet keine GaiaCom-native Ende-zu-Ende-Garantie, keine TrustMesh-Garantie und keine No-Godmode-Garantie ab dem Gateway.",
    "spam_verdacht": "Spam/Verdacht",
    "spam_warning_desc": "Diese Nachricht hat verdächtige Reputationssignale.",
    "spam_warning_title": "Spam-Warnung",
    "speichern": "Speichern",
    "sperren": "Sperren",
    "standard_group_status": "Standard-Gruppenchat (E2EE verschluesselt)",
    "status": "Status",
    "subject": "Betreff",
    "suchen": "Neue Gaia-Adresse suchen...",
    "tage": "Tage",
    "time_unknown": "Zeitpunkt unbekannt",
    "transmission_mode": "Übertragungsmodus",
    "trust_age": "Vertrauensalter",
    "trust_passport_title": "Trust Passport",
    "unbestaetigt": "Unbestätigt",
    "unknown_sender": "Unbekannt",
    "unlock_btn": "Entsperren",
    "unlock_btn_profile": "Freischalten",
    "unlock_desc": "Deine private Schlüsseldatei ist verschlüsselt gespeichert. Gib dein Passwort ein, um die kryptographischen Schlüssel nur im Arbeitsspeicher zu laden.",
    "unlock_logout": "Abmelden und lokale Schlüssel schließen",
    "unlock_title": "Identität entsperren",
    "untrusted": "Nicht vertrauenswürdig",
    "update_password": "Passwort aktualisieren",
    "upload_avatar_btn": "Bild hochladen (Sanitized)",
    "vault_btn_encrypt": "Record verschlüsseln",
    "vault_btn_lock": "Tresor sperren",
    "vault_btn_unlock": "Tresor entsperren",
    "vault_copied_success": "In die Zwischenablage kopiert",
    "vault_decrypted_content": "Entschlüsselter Inhalt",
    "vault_desc": "Lokaler verschlüsselter Tresor für Recovery-Backups, Identitätsnotizen, Server-Zugänge, Notfallkontakte, Rechtsnotizen, Security Events und private Logs.",
    "vault_empty": "Noch keine Secure Records gespeichert.",
    "vault_locked_pane_notice": "Tresor ist gesperrt. Bitte rechts entsperren.",
    "vault_new_record": "Neuer Secure Record",
    "vault_pwd_placeholder": "Vault-Passwort eingeben...",
    "vault_record_body": "Record-Inhalt",
    "vault_record_body_placeholder": "Verschlüsselten Record-Inhalt eingeben...",
    "vault_record_category": "Kategorie",
    "vault_record_title": "Record-Titel",
    "vault_record_title_placeholder": "Titel des Secure Records",
    "vault_title": "GaiaVault Secure Records",
    "verify_new_fingerprint_hint": "Prüfe den neuen Fingerprint, bevor du den Schlüssel akzeptierst.",
    "vertrauenswuerdig": "Vertrauenswürdig",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "Von",
    "warnung": "Warnung",
    "wizard_address": "Adresse",
    "wizard_back": "Zurück",
    "wizard_check1": "Ich habe meinen Seed sicher gespeichert.",
    "wizard_custom_domain": "Eigene Domain verwenden",
    "wizard_desc1": "GaiaCOM speichert private Schlüssel nicht serverseitig. Ohne Mnemonic Seed kann niemand verlorene Nachrichten wiederherstellen.",
    "wizard_desc2": "Deine Adresse bestimmt den föderierten Node, über den verschlüsselte Umschläge geroutet werden.",
    "wizard_fallback": "Fallback Nodes",
    "wizard_finish": "Einrichtung abschließen",
    "wizard_next": "Weiter",
    "wizard_server_domain": "Server-Node-Domain",
    "wizard_step1": "1. Backup Seed",
    "wizard_step2": "2. Adresse & Server",
    "wizard_title1": "Wiederherstellungs-Schlüssel sichern",
    "wizard_title2": "GaiaCOM-Adresse wählen",
    "write_message_placeholder": "Sichere Nachricht schreiben...",
    "you": "Du",
    "zero_knowledge": "Zero Knowledge",
    "zero_knowledge_encryption": "Zero-Knowledge Verschlüsselung",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "Die Chat-Nachricht wurde lokal aus deiner Inbox entfernt.",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "Ich bin für die sichere Aufbewahrung meiner Zugangsdaten selbst verantwortlich.",
    "wizard_check_is_beta": "Ich verstehe, dass GaiaCom Beta-Software ist.",
    "wizard_check_no_illegal": "Ich werde GaiaCom nicht für rechtswidrige Zwecke verwenden.",
    "wizard_check_no_uptime": "Ich verstehe, dass keine Verfügbarkeitsgarantie besteht.",
    "wizard_check_smtp_security": "Ich verstehe, dass SMTP-Nachrichten nicht den vollen GaiaCom-Sicherheitsumfang bieten.",
    "wizard_check_terms_read": "Ich habe die Beta-Nutzungsbedingungen gelesen.",
    "wizard_step_terms": "Nutzungsbedingungen",
    "wizard_terms_text": "Nutzungsbedingungen und Beta-Testvereinbarung für GaiaCom (Beta-Phase)\n\nAnbieterin: VisionGaiaTechnology (nachfolgend „Anbieterin“ genannt)\nStatus: Öffentliche Beta-Testphase\nGültigkeit: Ab dem 21. Juni 2026\n\n⚠️ DER WICHTIGSTE HINWEIS VORAB (BITTE AUFMERKSAM LESEN)\nGaiaCom befindet sich in einer öffentlichen Beta-Testphase. Trotz umfangreicher Sicherheitsmaßnahmen kann die Fehlerfreiheit, kontinuierliche Verfügbarkeit oder vollständige Datensicherheit der Software und der zugrundeliegenden Infrastruktur nicht garantiert werden. Die Nutzung erfolgt auf eigenes Risiko. Nutzer sind für die sichere Aufbewahrung ihrer Zugangsdaten (insb. Schlüssel für GaiaVault) sowie für die Einhaltung geltender Gesetze selbst verantwortlich.\n\n1. Gegenstand und Zweck der Beta-Testphase\n1.1. Zweck der Bereitstellung: GaiaCom ist ein neuartiger, auf Post-Quanten-Kryptografie (PQC) basierter E-Mail- und Chat-Dienst. Die Bereitstellung während der Beta-Phase dient ausschließlich der technischen Erprobung, der Lastsimulation, dem Finden von Programmfehlern (Bugs) sowie der Optimierung der Benutzerfreundlichkeit.\n1.2. Beta-Status: Dem Nutzer ist bewusst, dass es sich bei der angebotenen Software um eine Vorabversion (Beta-Software) handelt. Diese ist technisch noch nicht vollständig ausgereift, entspricht nicht dem Standard eines finalen, kommerziellen Produkts und kann Fehler, Datenverluste, Übertragungsverzögerungen oder Systemabstürze verursachen.\n1.3. Kein Anspruch auf Fortführung: Die Anbieterin ist jederzeit berechtigt, den Dienst ohne Angabe von Gründen ganz oder teilweise einzustellen, Funktionen zu verändern, einzuschränken oder temporär oder dauerhaft zu entfernen.\n\n2. Verfügbarkeit und Gewährleistungsausschluss\n2.1. Keine Verfügbarkeitsgarantie: Die Bereitstellung von GaiaCom erfolgt ohne jegliche Zusicherung von Verfügbarkeit oder Uptime. Es besteht kein Anspruch auf eine ununterbrochene Erreichbarkeit des Dienstes.\n2.2. Ausschluss der Gewährleistung: Die Software wird im aktuellen Zustand („as is“ / wie gesehen) und nach Verfügbarkeit bereitgestellt. Soweit gesetzlich zulässig, sind jegliche Gewährleistungsansprüche für Sach- und Rechtsmängel der Software ausgeschlossen. Insbesondere wird nicht garantiert, dass die Software fehlerfrei, frei von Schadsoftware oder für einen bestimmten Zweck geeignet ist.\n\n3. Risikomanagement und Pflichten der Nutzer\n3.1. Verbot der Speicherung kritischer Daten: Der Nutzer verpflichtet sich, über GaiaCom keine geschäftskritischen, lebenswichtigen, betriebsnotwendigen oder gesetzlich besonders schutzbedürftigen Daten (wie z.B. Patientenakten, hochsensible Finanzdaten oder behördlich regulierte Geheimnisse) ausschließlich zu speichern oder zu übertragen. Der Dienst darf nicht für Infrastrukturen genutzt werden, bei denen unvorhergesehene Ausfälle zu Personen-, Sach- oder erheblichen Vermögensschaben führen können.\n3.2. Eigenverantwortliches Backup: Der Nutzer ist selbst dafür verantwortlich, alle über GaiaCom empfangenen oder gesendeten Daten, die er langfristig benötigt, auf eigenen, unabhängigen Systemen (Sicherheitskopien) zu sichern. Die Anbieterin übernimmt keine Garantie für die dauerhafte Speicherung oder Wiederherstellbarkeit von Daten auf ihren Servern.\n\n4. Kryptografische Besonderheiten und GaiaVault\n4.1. Post-Quanten-Kryptografie (PQC): GaiaCom implementiert modernste, zukunftsweisende Verschlüsselungsverfahren, die auch Angriffen durch zukünftige Quantencomputer standhalten sollen. Dem Nutzer ist jedoch bewusst, dass es sich hierbei um ein dynamisches und neues wissenschaftliches Feld handelt. Eine absolute, unumstößliche Sicherheit kann nach dem aktuellen Stand der Wissenschaft und Technik nicht garantiert werden. Begrifflichkeiten wie „100 % sicher“, „unentschlüsselbar“ oder „hochgradig widerstandsfähig“ werden ausdrücklich nicht zugesichert.\n4.2. Keine Recovery-Garantie (GaiaVault): GaiaCom setzt auf ein konsequentes Zero-Knowledge-Sicherheitskonzept. Die Verschlüsselungskeile und Zugangsdaten verbleiben ausschließlich in der Kontrolle des Nutzers (gesichert über GaiaVault).\nWICHTIG: Verliert der Nutzer seine Passwörter, Passphrasen, privaten Schlüssel oder Wiederherstellungs-Seeds, hat die Anbieterin keinerlei technische Möglichkeit, diese Daten zu rekonstruieren oder zurückzusetzen. Ein Verlust dieser Zugangsdaten führt unweigerlich zum unwiderruflichen Verlust des Zugriffs auf das Benutzerkonto und alle darin verschlüsselten Daten.\n4.3. Noch nicht vollständig auditiert: Die Software wird kontinuierlich internen Sicherheitsprüfungen unterzogen, hat jedoch zum Zeitpunkt dieser Beta-Phase noch kein abschließendes, vollumfängliches externes Sicherheitsaudit durch unabhängige Prüfstellen durchlaufen.\n\n5. Schnittstellen, Legacy-Protokolle und Föderation\n5.1. SMTP-Bridge-Hinweis: GaiaCom bietet die Möglichkeit der Kommunikation über klassische E-Mail-Protokolle (wie SMTP). Dem Nutzer ist bewusst, dass Nachrichten, die den nativen GaiaCom-Sicherheitsraum verlassen (z.B. beim Senden an eine herkömmliche @gmail.com oder @gmx.de Adresse), über unverschlüsselte oder fremde Server transportiert werden. Die Ende-zu-Ende-Sicherheitsgarantien von GaiaCom gelten für solche ausgehenden oder von außen eingehenden Legacy-Nachrichten nur eingeschränkt bzw. gar nicht.\n5.2. Föderations-Hinweis: Sofern GaiaCom in einem föderierten Netzwerk betrieben wird, können Nachrichten und Daten über Server von Drittanbietern geleitet werden. Während die Inhalte der Nachrichten durch die Ende-zu-Ende-Verschlüsselung geschützt bleiben, können Metadaten (wie Sendezeitpunkt, IP-Adressen der beteiligten Server und Empfängeradressen) für die Betreiber dieser föderierten Server technisch sichtbar sein. Die Anbieterin hat keinen Einfluss auf die Datenschutzpraktiken dritter Serverbetreiber im föderierten Netzwerk.\n\n6. Zulässige Nutzung und Verbotene Aktivitäten\nDer Nutzer verpflichtet sich, den Dienst nicht missbräuchlich oder für rechtswidrige Zwecke zu verwenden. Untersagt sind insbesondere:\n- Die Verbreitung, der Versand oder das Hosten von Viren, Malware, Phishing-Inhalten oder anderer Schadsoftware.\n- Die Nutzung des Dienstes zur Durchführung von Denial-of-Service-Angriffen (DDoS) oder unaufgefordertem Massenversand (Spam).\n- Der Missbrauch des Systems zur Begehung von Betrugsdelikten.\n- Die Verbreitung oder der Austausch von illegalen Inhalten, insbesondere Darstellungen von sexuellem Missbrauch von Kindern (CSAM), terroristischer Propaganda, Gewaltaufrufen oder sonstigen strafrechtlich relevanten Inhalten.\n\n7. Missbrauchsmeldesystem (Abuse-System)\n7.1. Meldung missbräuchlichen Verhaltens: Nutzer haben die Möglichkeit, missbräuchliche Kommunikation oder illegale Aktivitäten über das integrierte Abuse-System zu melden.\n7.2. Verarbeitung von Meldungen: Um den Missbrauchsschutz zu gewährleisten, können eingehende Meldungen technisch (unter Wahrung der Privatsphäre und Verschlüsselungsgrenzen) analysiert werden. Dies kann bei nachgewiesenen Verstößen gegen diese Nutzungsbedingungen zu temporären oder dauerhaften Sperren von Benutzerkonten oder IP-Adressen führen.\n\n8. Haftungsbegrenzung\n8.1. Haftungsmaßstab: Die Bereitstellung der Beta-Software erfolgt unentgeltlich. Die Anbieterin haftet daher nach den gesetzlichen Regeln für Schenkung bzw. Leihe nur für Vorsatz (Vorsätzliche Schädigung) und grobe Fahrlässigkeit.\n8.2. Haftungsausschluss für Datenverluste: Die Haftung für den Verlust von Daten ist ausgeschlossen, es sei denn, der Verlust wurde durch die Anbieterin vorsätzlich oder grob fahrlässig herbeigeführt und der Nutzer hat durch regelmäßige Backups (außerhalb von GaiaCom) seiner Schadensminderungspflicht Genüge getan.\n8.3. Gesetzliche Grenzen: Die vorstehenden Haftungsbeschränkungen gelten nicht bei der Verletzung von Leben, Körper oder Gesundheit sowie bei der Haftung nach dem Produkthaftungsgesetz.\n\n9. Open Source\nBestimmte Komponenten, Bibliotheken oder Client-Anwendungen von GaiaCom können unter Open-Source-Lizenzen (z. B. GPL, MIT, Apache) lizenziert sein. Die jeweiligen Lizenzbedingungen dieser Komponenten bleiben von diesen Nutzungsbedingungen unberührt und sind in den entsprechenden Quelltext-Repositorys einsehbar.\n\n10. Exportkontrolle und Compliance\nDer Nutzer ist sich bewusst, dass kryptografische Software strengen Exportkontrollen und gesetzlichen Beschränkungen unterliegen kann. Der Nutzer ist selbst dafür verantwortlich, sicherzustellen, dass die Nutzung von GaiaCom nicht gegen die Gesetze, Import-/Exportbeschränkungen oder Kryptografie-Regulierungen seines jeweiligen Aufenthaltslandes verstoßt.\n\n11. Datenschutz-Hinweis (Kurzfassung für die Beta)\n11.1. Minimale Datenerhebung: Im Rahmen der Beta-Phase erhebt die Anbieterin nur solche Daten, die für den technischen Betrieb, die Fehlersuche und die Weiterentwicklung zwingend erforderlich sind (z. B. Server-Logdateien zur Fehlerdiagnose).\n11.2. Keine inhaltliche Einsicht: Durch die konsequente Zero-Knowledge- und E2E-Verschlüsselung hat die Anbieterin zu keinem Zeitpunkt Zugriff auf die Inhalte Ihrer Chats, E-Mails oder in der GaiaVault abgelegten Schlüssel.\n11.3. Detaillierte Datenschutzerklärung: Die detaillierten Datenschutzbestimmungen sind separat verlinkt und müssen vom Nutzer vor der Registrierung ebenfalls zur Kenntnis genommen werden.\n\n12. Schlussbestimmungen\n12.1. Anwendbares Recht: Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.\n12.2. Änderungsvorbehalt: Da sich GaiaCom in der aktiven Entwicklung befindet, behält sich die Anbieterin das Recht vor, diese Bedingungen jederzeit mit Wirkung für die Zukunft anzupassen. Die jeweils aktuelle Version ist in der Anwendung abrufbar.",
    "wizard_terms_title": "Nutzungsbedingungen und Beta-Testvereinbarung für GaiaCom (Beta-Phase)",
    "node_operator": "Node Operator",
    "search_channels": "Kanäle suchen...",
    "senior_reviewer": "Senior Reviewer",
    "trusted_reviewer": "Trusted Reviewer",
    "active_frequencies": "Aktive Frequenzen",
    "connected_rooms": "VERBUNDENE RÄUME",
    "dashboard": "Dashboard",
    "empty_chats": "Keine aktiven Chats vorhanden.",
    "empty_messages": "Keine neuen Nachrichten vorhanden.",
    "encrypted": "Verschlüsselt",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "App installieren",
    "install_app_desc": "Für schnellen Start & Offline-Modus",
    "kommandozentrale_alpha": "Kommandozentrale ALPHA",
    "network_online": "NETWORK: ONLINE",
    "new_room": "Neuer Raum",
    "no_frequencies_active": "Keine Frequenzen aktiv. Erstellen Sie einen neuen Raum, um die Kommunikation zu starten.",
    "no_id": "Keine ID",
    "open_chats": "Chats öffnen",
    "open_inbox": "Posteingang öffnen",
    "primary_identity": "PRIMÄRE IDENTITÄT",
    "recent_chats": "Neue Chats",
    "recent_messages": "Neueste Nachrichten",
    "session_encrypted": "Sitzung verschlüsselt: {name}",
    "session_secure": "STATUS: SECURE",
    "system_verlassen": "System verlassen",
    "write_message": "Nachricht schreiben",
    "onboarding_step_profile": "Profil",
    "onboarding_step_security": "Schutz",
    "onboarding_step_backup": "Backup",
    "onboarding_step_launch": "Start",
    "onboarding_loading_gaia_id": "Gaia-ID wird geladen",
    "onboarding_setup_kicker": "GaiaCom Initial Setup",
    "onboarding_profile_title": "Mach GaiaCom zu deinem Raum.",
    "onboarding_profile_desc": "Dein Anzeigename und Avatar bleiben lokal steuerbar und können später jederzeit im Profil geändert werden.",
    "onboarding_security_title": "Was GaiaCom gerade für dich schützt.",
    "onboarding_security_desc": "GaiaCom trennt Identität, Schlüssel, Nachrichten und Netzwerkstatus. Du siehst hier nur die kurze Nutzerfassung.",
    "onboarding_backup_title": "Ein Backup ist dein echter Notausgang.",
    "onboarding_backup_desc": "Ohne Wiederherstellungsdaten kann niemand deine Identität retten. Genau das ist der Punkt von echter Ende-zu-Ende-Sicherheit.",
    "onboarding_launch_title": "Bereit. Was willst du zuerst tun?",
    "onboarding_launch_desc": "Du kannst direkt loslegen oder den Rundgang beenden und im Dashboard weiterarbeiten.",
    "onboarding_display_name": "Anzeigename",
    "onboarding_display_name_placeholder": "Wie soll GaiaCom dich anzeigen?",
    "onboarding_select_avatar": "Avatar auswählen",
    "onboarding_sec_identity_title": "Identität",
    "onboarding_sec_identity_desc": "Deine Gaia-ID ist dein Netzwerkanker. Kontakte können Schlüsselwechsel erkennen.",
    "onboarding_sec_messages_title": "Nachrichten",
    "onboarding_sec_messages_desc": "Inhalte werden lokal entschlüsselt. Bearbeitete Nachrichten bekommen neue Signaturen.",
    "onboarding_sec_network_title": "Netzwerk",
    "onboarding_sec_network_desc": "Security Center und Abuse Center machen Risiken sichtbar, ohne globale Hintertür.",
    "onboarding_sec_transparency_title": "Transparenz",
    "onboarding_sec_transparency_desc": "Schreibt sicherheitsrelevante Ereignisse ins Protokoll, damit Warnungen nachvollziehbar bleiben.",
    "onboarding_backup_notice_title": "Wichtig für normale Nutzer",
    "onboarding_backup_notice_desc": "Speichere deine Wiederherstellungsdaten getrennt von diesem Gerät. Bei Verlust von Passwort und Backup bleibt GaiaCom absichtlich verschlossen.",
    "onboarding_backup_consent": "Ich weiß, dass mein Backup für Wiederherstellung und Gerätewechsel entscheidend ist.",
    "onboarding_inbox_title": "Posteingang",
    "onboarding_inbox_desc": "Mails lesen und erste Nachricht verfassen.",
    "onboarding_contacts_title": "Kontakte",
    "onboarding_contacts_desc": "Ersten Kontakt prüfen oder Chat starten.",
    "onboarding_channels_title": "Channels",
    "onboarding_channels_desc": "Öffentliche Frequenzen entdecken.",
    "onboarding_security_title_card": "Security Center",
    "onboarding_security_desc_card": "GaiaShield Status ansehen.",
    "onboarding_later": "Später",
    "onboarding_back": "Zurück",
    "onboarding_continue": "Weiter",
    "onboarding_complete_setup": "Setup abschließen",
    "auth_legal_consent": "Ich habe die Datenschutzbestimmungen und Nutzungsbedingungen gelesen und stimme ihnen zu.",
    "auth_show_terms": "Nutzungsbedingungen anzeigen",
    "auth_recovery_mode": "Recovery Modus",
    "auth_recovery_import_title": "Recovery-Datei importieren",
    "auth_recovery_import_desc": "Stelle deine GaiaCom Schluessel aus einer passwortgeschuetzten Backup-Datei wieder her. Danach sind Mnemonic und Nutzername vorausgefuellt.",
    "auth_recovery_file_pwd_placeholder": "Recovery-Datei Passwort",
    "auth_recovery_local_pwd_placeholder": "Neues lokales Entsperrpasswort min. 12 Zeichen",
    "auth_recovery_importing": "Importiere...",
    "auth_recovery_decrypt": "Recovery entschlüsseln",
    "auth_back_to_login": "Zurück zur Anmeldung",
    "auth_terms_title": "GaiaCom Beta Nutzungsbedingungen",
    "auth_terms_close": "Schließen",
    "auth_cookie_title": "GaiaCOM bleibt souverän.",
    "auth_cookie_desc": "Wir verwenden nur technisch notwendige lokale Speicherfunktionen für Sprache, Session und Sicherheit. Kein Tracking, keine Werbe-Cookies, keine Drittanbieter-Profile.",
    "auth_cookie_accept": "Verstanden",
    "sc_explainer_title": "Was wird hier eigentlich geschützt?",
    "sc_explainer_desc": "GaiaShield ist die Schutzschicht zwischen deinem Account, deinen Nachrichten und dem Netzwerk. Es entscheidet nicht über Inhalte, sondern über technische Risiken: Manipulation, Replay-Versuche, unautorisierte Zugriffe, auffällige Login-Muster und unsichere Gateway-Übergänge.",
    "sc_explainer_identity_desc": "Prüft Login-Anomalien, Session-Risiken und Zugriffe auf fremde Identitäten.",
    "sc_explainer_messages_desc": "Erkennt Replay-Muster, manipulierte Umschläge und fehlende Integritätsmerkmale.",
    "sc_explainer_network_desc": "Markiert Federation-, Rate-Limit- und SMTP-Risiken, bevor Vertrauen falsch angezeigt wird.",
    "sc_open_security_warnings": "Offene Sicherheitswarnungen",
    "sc_opt_all": "Alle",
    "sc_opt_low": "Niedrig",
    "sc_opt_medium": "Mittel",
    "sc_opt_high": "Hoch",
    "sc_opt_critical": "Kritisch",
    "sc_opt_failed_login": "Fehlgeschlagener Login",
    "sc_opt_auth_attack": "Auth-Angriff",
    "sc_opt_rate_limit": "Rate Limit",
    "sc_opt_policy_violation": "Richtlinien-Hinweis",
    "sc_opt_message_replay": "Nachrichten-Replay",
    "sc_node_security_data_unavailable": "Node-Sicherheitsdaten nicht verfügbar",
    "sc_total_events": "Ereignisse Gesamt",
    "sc_login_attacks": "Login Angriffe",
    "sc_rate_limits_active": "Rate Limits aktiv",
    "sc_smtp_shield_hits": "SMTP Shield Treffer",
    "sc_top_event_categories": "Top Ereigniskategorien",
    "sc_no_entries": "Keine Einträge.",
    "sc_node_audit_log": "Node-Audit-Protokoll (Letzte Events)",
    "sc_no_node_events": "Keine Node-Events.",
    "archiv": "Archiv",
    "entwuerfe": "Entwürfe",
    "markiert": "Starred",
    "wichtig": "Important",
    "snoozed": "Snoozed",
    "papierkorb": "Trash",
    "spam": "Spam",
    "cancel": "Abbrechen",
    "error": "Fehler",
    "success": "Erfolg",
    "kopieren": "Kopieren",
    "block_contact": "Kontakt blockieren",
    "unblock_contact": "Kontakt freigeben",
    "report_contact": "Kontakt melden",
    "check_fingerprint": "Fingerprint prüfen",
    "export_encrypted": "Export (Verschlüsselt)",
    "export_gaiaproof": "Export (GaiaProof)",
    "export_password_prompt": "Bitte geben Sie ein Passwort zur Verschlüsselung des Chat-Exports ein:",
    "export_success": "Chat wurde erfolgreich verschlüsselt exportiert.",
    "export_failed": "Export fehlgeschlagen: ",
    "gaiaproof_export_success": "GaiaProof-Paket wurde erfolgreich exportiert.",
    "gaiaproof_export_failed": "GaiaProof-Export fehlgeschlagen: ",
    "export_gaiaproof_confirm": "Möchten Sie das GaiaProof-Paket mit allen Signaturen und Server-Zustellnachweisen herunterladen? Dies kann einen Moment dauern.",
    "group_settings_is_private": "Privater Raum (nicht öffentlich durchsuchbar, Beitritt nur über Beitrittsanfragen)",
    "group_settings_read_only": "Nur-Lesen Modus (Nur Owner und Admins können Nachrichten senden)",
    "group_settings_slow_mode": "Slow Mode (Sende-Cooldown)",
    "gsn_title": "GSN Social Feed",
    "gsn_node_feed": "Node Feed",
    "gsn_following_feed": "Folge ich",
    "gsn_feed_empty": "Keine Beiträge gefunden.",
    "gsn_composer_placeholder": "Was gibt es Neues in der Föderation?",
    "gsn_post_btn": "Teilen",
    "gsn_profile": "Benutzerprofil",
    "gsn_followers": "Follower",
    "gsn_following": "Folge ich",
    "gsn_bio": "Beschreibung / Bio:",
    "gsn_bio_label": "Beschreibung / Bio",
    "gsn_display_name": "Anzeigename",
    "gsn_edit_profile": "Profil bearbeiten",
    "gsn_save_profile": "Speichern",
    "gsn_add_image": "Bild hinzufügen (Verschlüsselt)",
    "gsn_add_emoji": "Emoji einfügen",
    "gsn_avatar_emoji": "Avatar (Emoji)",
    "gsn_follow": "Folgen",
    "gsn_unfollow": "Entfolgen",
    "gsn_repost": "Teilen / Reposten",
    "gsn_post_created": "Beitrag erfolgreich geteilt.",
    "gsn_image_uploaded": "Bild wurde verschlüsselt und hochgeladen.",
    "gsn_upload_failed": "Bild-Upload fehlgeschlagen: ",
    "gsn_comment_placeholder": "Schreibe einen Kommentar...",
    "gsn_delete_confirm_title": "Beitrag löschen?",
    "gsn_delete_confirm_desc": "Bist du sicher, dass du diesen Beitrag unwiderruflich löschen möchtest?",
    "gsn_delete_comment_confirm_title": "Kommentar löschen?",
    "gsn_delete_comment_confirm_desc": "Bist du sicher, dass du diesen Kommentar unwiderruflich löschen möchtest?",
    "gsn_report": "Melden",
    "gsn_report_title": "Verstoß melden",
    "gsn_report_category": "Kategorie",
    "gsn_report_spam": "Spam / Werbung",
    "gsn_report_harassment": "Belästigung / Hassrede",
    "gsn_report_abuse": "Missbrauch",
    "gsn_report_illegal": "Illegale Inhalte",
    "gsn_report_severity": "Dringlichkeit",
    "gsn_report_low": "Niedrig",
    "gsn_report_medium": "Mittel",
    "gsn_report_high": "Hoch",
    "gsn_report_comment": "Zusätzlicher Kommentar",
    "gsn_report_submit": "Melden",
    "gsn_report_submitted": "Meldung wurde an die Governance übermittelt.",
    "gsn_report_post": "Beitrag melden",
    "report_group": "Gruppe melden",
    "report_group_reason_prompt": "Bitte geben Sie einen Grund für die Meldung ein (optional):",
    "report_reason_prompt": "Bitte geben Sie einen Grund für die Meldung ein (optional):",
    "report_failed": "Fehler beim Melden: ",
    "report_success": "Kontakt wurde erfolgreich gemeldet.",
    "room_read_only_placeholder": "Nur Owner und Admins können schreiben",
    "read_only_active": "Nur-Lesen Modus",
    "slow_mode_active": "Slow Mode aktiv",
    "kommandozentrale": "Kommandozentrale",
    "kontakt_blockiert": "Kontakt blockiert",
    "kontakt_freigegeben": "Kontakt freigegeben",
    "mailbox_settings_title": "Mailbox-Einstellungen",
    "mailbox_settings_desc": "Signatur, Sprache, Mail-Filter regeln.",
    "mic_access_denied": "Mikrofonzugriff verweigert: ",
    "no_frequencies_active_desc": "Erstellen Sie einen neuen Raum, um die Kommunikation zu starten.",
    "key_changed_warning_title": "SICHERHEITSHINWEIS:",
    "key_changed_warning_desc": "Der Identitätsschlüssel dieses Absenders wurde aktualisiert oder weicht von dem zuvor bekannten ab. Bitte bestätigen Sie den Fingerprint über einen anderen sicheren Kommunikationsweg.",
    "sc_col_category": "Kategorie",
    "search_members": "Mitglieder durchsuchen...",
    "tab_general": "Allgemein",
    "tab_members": "Mitglieder",
    "tab_requests": "Anfragen",
    "tab_invites": "Einladungen",
    "tab_logs": "Protokoll",
    "auth_why_gaiacom": "Warum GaiaCOM?",
    "auth_why_gaiacom_desc": "Die sichere, dezentrale Alternative für Ihre vertrauliche Kommunikation.",
    "auth_self_managed_id": "Selbstverwaltete ID",
    "auth_self_managed_id_desc": "Erstellen Sie sofort sichere kryptographische Identitäten ohne Angabe von E-Mail-Adresse oder Telefonnummer.",
    "auth_gaiadrop_secure_exchange": "Sicherer Austausch ohne Account",
    "auth_gaiadrop_benefit_e2ee": "Ende-zu-Ende verschlüsselt",
    "auth_gaiadrop_benefit_no_login": "Kein Login erforderlich",
    "auth_gaiadrop_benefit_inbox": "Direktempfang im Posteingang des Empfängers",
    "auth_terms_of_use": "Nutzungsbedingungen",
    "auth_terms_of_use_show": "Nutzungsbedingungen anzeigen",
    "auth_consent_privacy_terms": "Ich habe die Datenschutzbestimmungen und Nutzungsbedingungen gelesen und stimme ihnen zu.",
    "auth_recovery_import_file": "Recovery-Datei importieren",
    "auth_recovery_password": "Recovery-Datei Passwort",
    "auth_recovery_local_password": "Neues lokales Entsperrpasswort min. 12 Zeichen",
    "auth_recovery_decrypting": "Recovery entschlüsseln",
    "auth_recovery_back": "Zurück zur Anmeldung",
    "auth_cookie_sovereign": "GaiaCOM bleibt souverän.",
    "auth_cookie_sovereign_desc": "Wir verwenden nur technisch notwendige lokale Speicherfunktionen für Sprache, Session und Sicherheit. Kein Tracking, keine Werbe-Cookies, keine Drittanbieter-Profile.",
    "auth_cookie_sovereign_accept": "Verstanden",
    "unlock_keyboard_toggle": "⌨️ Tastatur verwenden",
    "unlock_keypad_toggle": "🔢 PIN-Pad verwenden",
    "unlock_status_denied": "ZUGRIFF VERWEIGERT / WIEDERHOLEN",
    "unlock_status_decrypting": "ENTSCHLÜSSELE TRESOR...",
    "unlock_status_secured": "TRESOR GESICHERT / GESPERRT",
    "auth_landing_nav_legal": "Rechtliches",
    "auth_landing_nav_beta": "Beta Test",
    "auth_landing_card1_title": "Post-Quanten-Krypto (ML-KEM)",
    "auth_landing_card2_title": "100% Dezentral",
    "auth_landing_card3_title": "Zero-Knowledge",
    "auth_landing_card4_title": "Metadaten-Schutz",
    "auth_landing_card5_title": "Selbstverwaltete ID",
    "auth_landing_hybrid_title": "Heutige Kryptografie plus Schutz gegen morgen.",
    "auth_landing_hybrid_desc": "GaiaCom kombiniert bewährten klassischen Schlüsselaustausch mit Post-Quantum-Key-Encapsulation. Kein blindes Entweder-oder — sondern Defense in Depth.",
    "auth_landing_x25519_desc": "Bewährter, schneller elliptischer Schlüsselaustausch für heutige Geräte und sichere Sessions.",
    "auth_landing_mlkem_desc": "Post-Quantum-Key-Encapsulation für langfristige Vertraulichkeit gegen Harvest-now-decrypt-later-Szenarien.",
    "auth_landing_cycle_title": "Der Server sieht nichts. Das Netzwerk transportiert nur Rauschen.",
    "auth_landing_step1_title": "Lokale Verschlüsselung",
    "auth_landing_step1_desc": "Die Nachricht wird auf dem Gerät des Absenders verschlüsselt — bevor sie Netzwerk oder Server erreicht.",
    "auth_landing_step2_title": "Transport als Blob",
    "auth_landing_step2_desc": "Das Paket reist als kryptografisches Rauschen durch Föderation, Nodes oder dezentrale Speicherlayer.",
    "auth_landing_step3_title": "Federated Storage",
    "auth_landing_step3_desc": "Keine zentrale Mailbox als Honigtopf. Daten liegen fragmentiert, föderiert oder dezentral verschlüsselt vor.",
    "auth_landing_step4_title": "Lokale Entschlüsselung",
    "auth_landing_step4_desc": "Nur der private Schlüssel des Empfängers kann den Blob wieder in Inhalt verwandeln.",
    "auth_landing_trinity_title": "Eine Protokollidee. Drei Infrastruktur-Level.",
    "auth_landing_enterprise_desc": "Für Unternehmen, Kanzleien, Mittelstand, Industrie und Private Banking. Geschlossene Kommunikationskreise mit administrativer Kontrolle, Compliance und Support.",
    "auth_landing_enterprise_list1": "Interne Souveränität und User-Verwaltung",
    "auth_landing_enterprise_list2": "Self-hosted Node oder Managed Sovereign Cluster",
    "auth_landing_enterprise_list3": "SLA, Support und Premium-Module",
    "auth_landing_network_desc": "Das offene Netz für digitale Privatsphäre. Keine Plattform für Datenhandel, sondern Infrastruktur für freie und verschlüsselte Kommunikation.",
    "auth_landing_network_list1": "Open Source Client",
    "auth_landing_network_list2": "Föderierte Nodes",
    "auth_landing_network_list3": "Kein zentraler Leseschlüssel",
    "auth_landing_defend_desc": "Spezialisierte Hochsicherheits-Infrastruktur für Behörden, kritische Infrastrukturen und isolierte Kommunikationssilos.",
    "auth_landing_defend_list1": "Air-gapped und isolierte Deployments",
    "auth_landing_defend_list2": "White Labeling und Source Code Audit",
    "auth_landing_defend_list3": "Nationale digitale Souveränität",
    "auth_landing_gov_title": "Open protocol. Commercial execution. Klare juristische Trennung.",
    "auth_landing_gov_desc": "GaiaCom trennt öffentliches Protokoll, offene Clients und kommerzielle Premium-Infrastruktur. Vertrauen entsteht durch Transparenz — Umsatz durch Enterprise-Betrieb, Support, Integrationen und spezialisierte Module.",
    "auth_landing_price1_desc": "Bot-Protection-Fee für AppStore/PlayStore-Verteilung.",
    "auth_landing_price2_desc": "Open Source für Nutzer, die selbst kompilieren möchten.",
    "auth_landing_price3_desc": "Für Mittelstand, Kanzleien und sensible Teams.",
    "auth_landing_price4_desc": "Für Konzerne, HA-Cluster, LDAP und Godmode Admin.",
    "auth_landing_license1_desc": "Maximale Transparenz für Nutzer, Forks und Community-Audits.",
    "auth_landing_license2_desc": "Copyleft-Schutz gegen Cloud-Theft und geschlossene Protokoll-Forks.",
    "auth_landing_license3_desc": "LDAP, Godmode, Audit, SLA und spezialisierte Business-Logik.",
    "auth_landing_final_title": "Kommunikation nach dem Vertrauensmodell.",
    "auth_landing_final_desc": "GaiaCom ersetzt nicht einfach E-Mail. GaiaCom stellt die Frage, warum vertrauliche Kommunikation im Jahr der Post-Quantum-Migration noch immer auf zentralen Postfächern, lesbaren Servern und 40 Jahre alten Annahmen basiert.",
    "auth_landing_final_note": "Hinweis: Diese Landingpage beschreibt eine Architekturvision und Produkt-Roadmap. Sicherheitsversprechen müssen vor produktivem Einsatz durch Implementierung, Audits und reale Tests bestätigt werden."




  };

export default de;
